import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetMessagesList = (options = {}) => {
  const query = useApiQuery(
    ['bup-modes-messages'],
    'schools',
    '/current-organization/bup-modes?limit=1000&offset=0',
    options,
    { authenticated: true, version: 3 }
  )

  const messagesList = Array.isArray(query.data)
    ? [...query.data].sort((a, b) => {
        const aTime = new Date(a?.createdAt ?? 0).getTime()
        const bTime = new Date(b?.createdAt ?? 0).getTime()
        return bTime - aTime
      })
    : []

  return {
    loadingMessages: query.isLoading,
    isFetchingMessages: query.isFetching,
    messagesList,
    errorMessagesList: query.isError ? query.error : null,
    getMessagesList: query.refetch
  }
}
